<template>
  <transition name="slide-fade" mode="out-in">
    <!-- <div v-if="errorWrongPracticeAnswer"> -->
    <div class="alert alert-danger">
      <h2>Not quite right</h2>
      <hr>
      <h4>Check Bob's story above, and then try again.</h4>
    </div>
    <!-- </div> -->
  </transition>
</template>

 <script>
export default {};
</script>

 <style>
/* Vue Transitions */

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.slide-fade-enter-active {
  transition: opacity 2s ease-in-out, max-height 1s linear;
}

.slide-fade-leave-active {
  transition: opacity 0.5s ease-in-out, max-height 1s linear;
}

.slide-fade-enter-to,
.slide-fade-leave {
  opacity: 1;
  max-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPracticeWrongAnswer.vue